import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Company } from '../../onboarding/classes/company';

@Injectable()
export class CompanyService {

  constructor(private http: Http) { }

  getCompanies() {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(environment.companiesUrl, options)
      .map(res => res.json())
  }

  getCompany(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}.json`, options)
      .map(res => res.json())
  }

  addCompany(info: Company) {
    let data: any = { company: [info.company] };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(environment.companiesUrl, data, options)
      .map(res => res.json())
  }

  deleteCompany(id: number) {
    console.log(id)
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${id}.json`, options)
      .map(res => res.json())
  }

  complete(orgId: number) {
    let data = { id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.put(`${environment.organizationsUrl}${orgId}/submit.json`, data, options)
      .map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/company.service.ts